<ul dense class="list-details list-unstyled" *ngIf="company">
    <li *ngIf="company.companySummary && company.companySummary.businessName" >
        <div class="list-grid">
            <div class="text-wrap">{{company.companySummary.businessName}}</div>
        </div> 
    </li>
    <mat-divider></mat-divider>
    <div class="h5 fw-bold my--16">Sede</div>
    <li>
        <div class="list-grid">
            <span  class="text-wrap">{{company.alternateSummary.address}}</span>
        </div>
    </li>
    <mat-divider></mat-divider>
    <div class="h5 fw-bold  my--16">Informazioni</div>
    <ng-container *ngIf="company.alternateSummary">
        <li>
            <div class="list-grid">
                <label class="fw-bold" translate>label.ragioneSociale</label>
                <span  class="text-wrap">{{company.companySummary.businessName}}</span>
            </div>
        </li>

        <li >
            <div class="d-flex flex-wrap gap-16">
            
            <div class="list-grid" *ngIf="company.alternateSummary.vatRegistrationNumber">
                <label  class="fw-bold" translate>label.vatNumber </label>
                <span  class="text-wrap">{{company.alternateSummary.vatRegistrationNumber}}</span>
            </div>
             <div class="list-grid" *ngIf="company.alternateSummary.taxCode">
                <label class="fw-bold" translate>label.tax_code </label>
                <span  class="text-wrap">{{company.alternateSummary.taxCode}}</span>
            </div>
        </div>
        </li>
        <li >
            <div class="d-flex flex-wrap gap-16">
            <div class="list-grid" *ngIf="company.alternateSummary.companyRegistrationNumber">
                <label class="fw-bold"><span translate>label.rea_code</span></label>
                <span  class="text-wrap">
                    {{company.alternateSummary.companyRegistrationNumber}}
                </span>
            </div>
            <div class="list-grid" *ngIf="company.alternateSummary.numberOfEmployees">
                <label class="fw-bold" translate>label.employees </label>
                <span  class="text-wrap">{{company.alternateSummary.numberOfEmployees}}</span>
            </div></div>
        </li>
     </ng-container>
<!-- <ng-container *ngIf="company.alternateSummary">
    <li *ngIf="company.companyIdentification?.principalActivity?.description">
        <div class="list-grid">
            <label class="fw-bold" translate>label.principal_activity </label>
            <span  class="text-wrap">{{company.companyIdentification?.principalActivity?.description}}</span>
        </div>
    </li>
    
        <li>
            <div class="list-grid">
                <label class="fw-bold"><span translate>label.rea_code</span> - <span translate>data iscrizione</span></label>
                <span  class="text-wrap">
                    {{company.alternateSummary.companyRegistrationNumber}} - {{company.alternateSummary.reaInscriptionDate | date }}
                </span>
            </div>
        </li>
        <li>
            <div class="list-grid">
                <label class="fw-bold" translate>label.start_operation_date </label>
                <span  class="text-wrap">
                    {{company.alternateSummary.incorporationDate | date}}
                </span>
            </div>
        </li>
        <li>
            <div class="list-grid">
                <label class="fw-bold" translate>label.share_capital </label>
                <span  class="text-wrap">
                    {{company.alternateSummary.shareCapital|currency }}
                </span>
            </div>
        </li>
        <li>
            <div class="list-grid">
                <label class="fw-bold" translate>label.latest_turnover_figure</label> 
                <span  class="text-wrap">
                    {{ company.alternateSummary.latestTurnoverFigure.value|currency }}
                </span>
            </div>
        </li>
        <li *ngIf="company.alternateSummary.numberOfEmployees">
            <div class="list-grid">
                <label class="fw-bold" translate>label.employees </label>
                <span  class="text-wrap">{{company.alternateSummary.numberOfEmployees}}</span>
            </div>
        </li>

         <li *ngIf="company.alternateSummary.mainActivity" >
            <div class="list-grid">
                <label class="fw-bold" translate>label.ateco_code </label>
                <span  class="text-wrap">{{ company.alternateSummary.mainActivity.code }} - {{ company.alternateSummary.mainActivity.description }}</span>
            </div>
        </li> 
    </ng-container> -->
</ul>